const OurTeamDetails = {
    faculty:[
        {
            Name:"Dr. Anusha Kannan",
            image_url:"https://res.cloudinary.com/dsolrmyfj/image/upload/v1671513174/Fac_srhdnx.png",
            role:"Associate Professor",
            quote:"Computer Science professor at VIT Chennai. PhD from VIT Vellore in network security. She loves preparing club members for their futures.",
            linkedIn:"",
        },
        {
            Name:"Dr. Braveen M",
            image_url:"https://res.cloudinary.com/dsolrmyfj/image/upload/v1672067311/WhatsApp_Image_2022-12-26_at_8.24.19_PM_n5qwvu.jpg",
            role:"Associate Professor",
            quote:"As the mentor and faculty coordinator for the club, Sir is dedicated to guiding and supporting the next generation of leaders.",
            linkedIn:"",
        },
    ],
    president:[
        {
        Name:"Sam Prince Franklin",
        image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671954646/WhatsApp_Image_2022-12-25_at_12.54.43_PM_yy4sjw.jpg",
        role:"President",
        quote:"juggling tasks, giggling through it all",
        linkedIn:"https://www.linkedin.com/in/samprincefranklin/"
    },
    ],
    vice_president:[
        {
            Name:"Shreejith SG",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978208/IMG_20221225_134342_-_SHREEEJITH_SG_20BCE1376_tz3wja.jpg",
            role:"Vice President",
            quote:"Never give up because its never too late to achieve anything.",
            linkedIn:"https://www.linkedin.com/in/shreejithsg" 
        },
    ],
    heads:[
        {
            Name:"Dewanshi Paul",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671513180/GenSec_fvlxcy.jpg",
            role:"General Secretary",
            quote:"Results happen over time, not overnight-work hard and be patient.",
            linkedIn:"https://www.linkedin.com/in/dewanshi-paul-2515091b9/" 
        },
        {
            Name:"Venkat Amith Woonna",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671512654/Principlesec_qcimop.png",
            role:"Principle Secratary",
            quote:"Simply Curious",
            linkedIn:"https://www.linkedin.com/in/venkat-amith-woonna-38bb721b8" 
        },
        {
            Name:"Deepthi B",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671543627/JointGenSec_ragypk.jpg",
            role:"Joint General Secretary",
            quote:"Learn and Explore!",
            linkedIn:"https://www.linkedin.com/in/deepthibalasubramanian" 
        },
        {
            Name:"Neeraj J Manurkar",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671512475/TechHead_nblxff.jpg",
            role:"Technical Head",
            quote:"Good people are good because they've come to wisdom through failure",
            linkedIn:"https://www.linkedin.com/in/neeraj-j-manurkar-64372b212/" 
        },
        {
            Name:"Shyam Sundhar G",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671512617/shyam_g7ze3n.jpg",
            role:"Dev Lead",
            quote:"Work Hard Anywhere",
            linkedIn:"https://www.linkedin.com/in/shyamsundhar2435/" 
        },
        {
            Name:"Samarth Asthan",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978204/52A1F80B-C262-4FE2-8390-32AD787D714B_-_Samarth_Asthan_21BRS1248_i96emj.jpg",
            role:"App Development Head",
            quote:"Progressive, Quick Learner and Versatile in New Technologies",
            linkedIn:"https://www.linkedin.com/in/samarthasthan/" 
        },
        {
            Name:"Aravind P",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671543609/aravindp_gqnn3m.jpg",
            role:"Web Dev Lead",
            quote:"Proficient Professional Pragmatic Pythonic Programmer",
            linkedIn:"https://www.linkedin.com/in/aravind-p-92a5061b8/" 
        },
        {
            Name:"Kiranraaj Sekar",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671543619/kiran_dzvwxp.jpg",
            role:"Web Dev Lead",
            quote:"Linux enthusiast with unhealthy love for rust",
            linkedIn:"https://www.linkedin.com/in/kiranraaj-sekar-a950081b9/" 
        },
        {
            Name:"Kaifur Rahman",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978207/IMG_1976_-_Kaifur_Rahman_21BRS1147_anhtdh.jpg",
            role:"Web Dev Head",
            quote:"Positive mindset and enjoys challenges because hardwork never bothers me.",
            linkedIn:"https://www.linkedin.com/in/kaifur-rahman" 
        },
        {
            Name:"Akilesh S",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978204/8817_-_Copy.JPG_-_Akilesh_S_21MIS1167_pn1phu.jpg",
            role:"Web Dev Head",
            quote:"Making the World a Better Place ⚡",
            linkedIn:"https://www.linkedin.com/in/akilesh-s-5b4b8374/" 
        },
        {
            Name:"Gokulrupachandran",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978205/1666193670604_-_RUPACHANDRAN_20MIA1132_w1wtbl.jpg",
            role:"Cyber Security Lead",
            quote:"Security is a Myth",
            linkedIn:"https://www.linkedin.com/in/rupachandrans/" 
        },
        {
            Name:"Muhammed Riyaz S",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978204/270207219_718026219602318_4536025956078904265_n_-_Muhammed_Riyaz_S_21BPS1147_gckzts.jpg",
            role:"Cyber Security Head",
            quote:"El Que No Arriesga, No Gana",
            linkedIn:"https://www.linkedin.com/in/muhammedriyazs" 
        },
        {
            Name:"Nalin Iyer",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978205/IMG-20220610-WA0017_-_Nalin_Iyer_21BRS1631_tqnrdf.jpg",
            role:"Cyber Security Head",
            quote:"Trust no one, verify everything.",
            linkedIn:"https://www.linkedin.com/in/nalin-iyer" 
        },
        {
            Name:"Marian George",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978205/id_pic_-_Marian_George_21BAI1726_uq2rhr.jpg",
            role:"Cyber Security Head",
            quote:"Nothing is apparent.",
            linkedIn:"https://www.linkedin.com/in/marian-george-718bb6219" 
        },
        {
            Name:"Aneesh Aparajit G",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978206/IMG-20221206-WA0014_-_ANEESH_APARAJIT_G_20BRS1054_agfgkk.jpg",
            role:"AI/ML Lead",
            quote:"Bhaad mein jaa... ",
            linkedIn:"https://www.linkedin.com/in/aneesh-aparajit" 
        },
        {
            Name:"Sanjay Saju Jacob",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978207/IMG20220811115534_-_SANJAY_SAJU_JACOB_20BAI1139_ytqijs.jpg",
            role:"Competitive Programming Lead",
            quote:"I mod U 3000",
            linkedIn:"https://www.linkedin.com/in/sanjay-saju-jacob-ab738a1bb/" 
        },
        {
            Name:"Appana Jaya Ratna Uttam ",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978208/IMG_20221224_112135_-_Appana_Jaya_Ratna_Uttam_21BCE5766_chdvi5.jpg",
            role:"Competitive Coding Head",
            quote:"All human wisdom is summed up in two words; patience and hope!",
            linkedIn:"https://www.linkedin.com/in/jayaratnauttam-appana-148562239" 
        },
        {
            Name:"Kevin Gandhi ",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1672129799/kevinimage_-_KEVIN_GANDHI_20BCE1377_x0odtu.jpg",
            role:"Competitive Coding Head",
            quote:"Life isn't about finding yourself. Life is about creating yourself.",
            linkedIn:"https://www.linkedin.com/in/kevin-gandhi-7a26b61b8/" 
        },
        
        {
            Name:"P.Je Sai Kailash",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671543632/Prhead_lhcdes.jpg",
            role:"Management Lead",
            quote:"Having the dream is easy, making it come true is hard",
            linkedIn:"https://www.linkedin.com/in/je-sai-kailash-pulipati-347180202/" 
        },
        {
            Name:"Ramireddy Jeevan Reddy",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978204/05899605-2188-409A-AE2E-30C784306A9F_-_Ramireddy_Jeevan_Reddy_21BCE5163_r8n5tg.jpg",
            role:"Management Head",
            quote:"Jeevan Reddy",
            linkedIn:"https://www.linkedin.com/mwlite/in/ramireddy-jeevan-reddy-731a4b233" 
        },
        {
            Name:"Varshith R P",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978208/IMG_20220810_131231_Bokeh_polarr_2_-_Varshith_R_P_21BRS1366_fju4e0.jpg",
            role:"Marketing and PR Head",
            quote:"Gregarious!",
            linkedIn:"https://www.linkedin.com/in/varshith-r-p-82ba15234" 
        },
        {
            Name:"Shashannk S",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978208/MIC_Shashannk_-_Shashannk_S_21BRS1241_kau5n5.jpg",
            role:"Marketing & PR Head",
            quote:"My existence is a scandal for the antagonist",
            linkedIn:"http://www.linkedin.com/in/shashannk-s-316a06236" 
        },
        {
            Name:"K Ravi Teja ",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978207/IMG20221218141038_-_Kilaparthi_Ravi_Teja_21BCE5627_gxzhyf.jpg",
            role:"Marketing and PR Head",
            quote:"With the new day comes new strength and new thoughts",
            linkedIn:"https://www.linkedin.com/in/ravi-teja-1b70b2250" 
        },
        {
            Name:"Muskaan Yadav",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978209/Muskaan-pic_-_MUSKAAN_YADAV_20BCE1622_ceew0c.jpg",
            role:"Design and Content Lead",
            quote:"Strive for progress not perfection",
            linkedIn:"https://www.linkedin.com/in/muskaan-yadav-068/" 
        },
        {
            Name:"Dharshan S",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978207/IMG_20200307_180629_Bokeh_-_Dharshan_S_21BCE1634_kfmjzc.jpg",
            role:"Design Head",
            quote:"Efficacious Tech Savvy with Creative Ingenuity",
            linkedIn:"https://www.linkedin.com/in/dharshan-shankar-66b01723a" 
        },
        {
            Name:"Anikaet Irkal",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978207/IMG_20220205_202957_-_Anikaet_Irkal_21BMH1073_nz3a4i.png",
            role:"Design Head",
            quote:"It takes a lot of balls to golf the way I do",
            linkedIn:"https://www.linkedin.com/in/anikaetirkal" 
        },
        {
            Name:"Anuranjan Vikas",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978208/IMG_2379_-_Anuranjan_Vikas_A_21BPS1073_qwtozn.jpg",
            role:"Design Head",
            quote:"How About Now? You Still Wired In?",
            linkedIn:"https://www.linkedin.com/in/anuranjan-vikas-134538215" 
        },
        {
            Name:"Anadi Goswami",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978204/75F8BC52-02BE-441B-9FF5-54EF5A99C305_-_Anadi_Goswami_21BCE5340_uvz4yy.jpg",
            role:"Video Editing Head",
            quote:"Nostalgia was better when I was growing up",
            linkedIn:"https://www.linkedin.com/in/anadi-goswami-6326b3234" 
        },
        {
            Name:"Sahil Sharma",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978209/Screenshot_2022_0925_212931_-_Sahil_Sharma_21BLC1414_aavgjj.jpg",
            role:"Photography Head",
            quote:"Achha thik hai samajh gaya",
            linkedIn:"https://www.linkedin.com/in/sahil-sharma-885b04225" 
        },
        {
            Name:"S Tejas Krishna",
            image_url: "https://res.cloudinary.com/dsolrmyfj/image/upload/v1671978205/IMG-20221224-WA0000_-_Tejas_Krishna_S_21BCE1417_teooqr.jpg",
            role:"Sponsorship Lead",
            quote:"Quality never goes out of style",
            linkedIn:"http://www.linkedin.com/in/tejas-krishna-886812224" 
        },
    ]
}

export default OurTeamDetails;